module.exports = __webpack_public_path__ + "static/img/propaganda-3.3df3792f.jpeg";